import { Component, DestroyRef, inject, Input } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { emailValidator } from 'src/app/validators/email.validator';

import { CommonModule } from '@angular/common';
import { FormatPhoneUsDirective } from '../../../directives/format-phone-us.directive';
import { FormatEmailDirective } from '../../../directives/format-email.directive';
@Component({
    selector: 'app-assign-users',
    templateUrl: './assign-users.component.html',
    styleUrl: './assign-users.component.css',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FormatPhoneUsDirective,
        FormatEmailDirective
    ]
})
export class AssignUsersComponent {
  @Input() customerDataInput: any;
  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()]),
  });

  get emailModel() {
    return this.form.get('email');
  }

  information: string = 'Assign User';
  customerName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  states: MasterDataDTO[] = [];
  contactNumber?: string = undefined;
  email: string = '';
  fieldsCompleted: boolean = false;
  CustomerMessageError: string = '';
  masterdataRequestDTO: MasterdataRequestDTO = {
    idMaster: 1,
  };
  validMail: boolean = false;

  alert: Alert = {} as Alert;
  customer: UserDTO = {
    userAddressLine1: '',
    userAddressLine2: '',
    userCity: '',
    userMail: '',
    userExpirationPass: new Date('2020-05-05'),
    userNames: '',
    userPassword: '',
    userPhone: undefined,
    userPostalCode: undefined,
    userRegister: new Date('2020-05-05'),
    userState: '',
    userId: undefined,
    userStatus: undefined,
    numberPlans: undefined,
    numberDevices: undefined,
    listUserRole: [],
    listUserPlanDev: [],
  };

  constructor(
    private customerService: CustomerService,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    const destroyed = new Subject();

    this.permissionsService.validateAccessLevels(MODULE_ID.Customers);         //ToDo: ?????  это ошибка? может быть UserManagement?
    this.customerService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleGetAllStatesSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.CustomerMessageError = 'Unexpected error. Please try again later.';
        this.clearFields();
      }
    );
  }

  ngOnChanges() {

  }

  //Este metodo se ejecuta cuando se presiona el boton de regresar
  goBack() {
    // this.router.navigate(['/customers'], {
    //   relativeTo: this.route,
    //   state: { customerData: this.customerDataInput },
    // });
    window.history.back();
  }

  createUserCustomer() {

    const destroyed = new Subject();

    this.customer.userId = this.customerDataInput.userId;
    this.customer.userAddressLine1 = this.address;
    this.customer.userPhone = this.contactNumber;
    this.customer.userNames = this.customerName;
    this.customer.userMail = this.email;
    this.customer.userState = this.stateSelected;
    this.customer.userPostalCode = this.zipCode;
    this.customer.userCity = this.city;

    this.customerService.saveCustomerUser(this.customer).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null
          ? this.handleSaveSuccess(Data)
          : this.handleSaveError(StatusCode),
      (error) => {
        this.CustomerMessageError = 'Unexpected error. Please try again later.';
        this.clearFields();
      }
    );
  }

  checkFields() {
    this.checkEmailValidity();
    if (this.customerName && this.contactNumber && this.email && this.validMail) {
      this.fieldsCompleted = true;
    } else {
      this.fieldsCompleted = false;
    }
  }

  handleSaveError(StatusCode: number) {
    this.CustomerMessageError = 'Unexpected error';
    this.clearFields();
  }

  async handleSaveSuccess(customer: UserDTO) {
    //console.log(customer.userId);
    if (customer.userId === 0) {
      this.alert = {
        alertMessage: 'This user already exists',
        alertType: 'alert alert-warning',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };

      this.alertService.updateAlertState(this.alert);
    } else {
      this.alert = {
        alertMessage: 'User saved successfully',
        alertType: 'alert alert-success',
        alertCenter: false,
        alerTitle: '',
        duration: 3000,
      };
      localStorage.setItem('AlertObject', JSON.stringify(this.alert));
      this.alertService.updateAlertState(this.alert);

      this.clearFields();
      location.reload();
    }
  }
  handleGetAllStatesSuccess(states: MasterDataDTO[]) {
    this.states = states;
  }

  clearFields() {
    this.address = '';
    this.contactNumber = undefined;
    this.customerName = '';
    this.email = '';
    this.stateSelected = '';
    this.zipCode = undefined;
    this.city = '';
  }

  checkEmailValidity() {
    const isValid = this.emailModel?.valid;
    if (isValid) {
      this.validMail = true;
    } else {
      this.validMail = false;
    }
  }
}
